<template>
    <section class="container mt-5">
        <div class="row">
            <div class="col-12 mb-5 text-center">
                <h3 class="text-uppercase">Articoli</h3>
            </div>
            <b-card-group columns>
                <b-card v-for="(post, index) in posts" :key="index" :img-src="post.images" img-alt="Image"
                    class="text-dark" img-top>
                    <b-link :href="post.url" target="_blank" class="stretched-link">
                        <h5 class="card-title">{{ post.title }}</h5>
                    </b-link>
                    <p class="card-text" v-html="post.sub_title"></p>
                </b-card>
            </b-card-group>
            <button v-if="page != totalPages" type="button" v-on:click="loadMore()"
                class="btn text-uppercase more-article btn-light py-3 px-5 mx-auto mt-5 d-flex align-items-center justify-content-center">
                <font-awesome-icon class="mr-4" :icon="['fas', 'chevron-down']" />
                carica altri articoli
                <font-awesome-icon class="ml-4" :icon="['fas', 'chevron-down']" />
            </button>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Articles',
    data() {
        return {
            posts: [],
            page: 1,
            totalPages: null
        }
    },
    methods: {
        fetchData() {
            fetch('https://garage.pizza/wp-json/app/v1/article/event/' + this.page)
                .then((r) => r.json())
                .then((res) => {
                    this.posts = res.data;
                    this.totalPages = res.totalPages
                });
        },
        loadMore() {
            this.page = this.page + 1;
            fetch('https://garage.pizza/wp-json/app/v1/article/event/' + this.page)
                .then((r) => r.json())
                .then((res) => {
                    for (let i = 0; i < res.data.length; i++) {
                        this.posts.push(res.data[i]);
                    };
                })
        }
    },
    mounted() {
        this.fetchData();
    }
}
</script>


<style scoped>
.card {
    color border: 0;
    border-radius: 50px;
    background: transparent;
    overflow: hidden;
    border: 4px solid rgb(0 0 0 / 15%);
}

.card-body {
    background: #fff;
}

.card-title {
    font-weight: 700;
    font-size: 24px;
}

.more-article {
    border-radius: 50px; 
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/Articles.vue